export default __webpack_public_path__ + "static/media/StartEarningNow.60901c88.mp4";